export const selectDropdownLayerConfig = {
  dropdownParent: "body",
  onInitialize() {
    const select = this;
    const modal = select.input.closest(".modal");
    const parent = modal || document.body;
    parent.appendChild(select.dropdown);
    select.dropdown.classList.add("select-dropdown-layer");

    // Stay inside the modal focus trap, outside its scrolling/clipping content.
    select.positionDropdown = () => {
      const rect = select.control.getBoundingClientRect();
      select.dropdown.style.width = `${rect.width}px`;
      const below = window.innerHeight - rect.bottom - 8;
      const above = rect.top - 8;
      const openAbove = below < 180 && above > below;
      const headerHeight = select.dropdown.offsetHeight - select.dropdown_content.offsetHeight;
      select.dropdown_content.style.maxHeight = `${Math.max(0, Math.min(300, (openAbove ? above : below) - headerHeight))}px`;
      const parentRect = modal ? modal.getBoundingClientRect() : { top: 0, left: 0 };
      const scrollTop = modal ? modal.scrollTop : window.scrollY;
      const scrollLeft = modal ? modal.scrollLeft : window.scrollX;
      const top = openAbove ? rect.top - select.dropdown.offsetHeight : rect.bottom;
      select.dropdown.style.top = `${top - parentRect.top + scrollTop}px`;
      select.dropdown.style.left = `${rect.left - parentRect.left + scrollLeft}px`;
    };

    const close = () => select.close();
    const onScroll = (event) => {
      if (select.isOpen && !select.dropdown.contains(event.target)) close();
    };
    document.addEventListener("scroll", onScroll, true);
    modal?.addEventListener("hide.bs.modal", close);
    select.on("destroy", () => {
      document.removeEventListener("scroll", onScroll, true);
      modal?.removeEventListener("hide.bs.modal", close);
    });
  },
};
